/**
 * Update location of camera marker for camera.
 * @param {Object} camera - Current camera.
 * @param {Object} action - Details of the current request.
 * @return {Object} Updated camera with the unit of measurement switched.
*/

export default function updateLocation(camera, value) {
  return Object.assign({}, camera, {
    location: typeof value.lat === 'function' ? { lat: value.lat(), lng: value.lng() } : { lat: value.lat, lng: value.lng }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateLocation.js